export type Booleanish = boolean | 'true' | 'false';
